
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":".1","fill":"currentColor","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M12.141 16.522a.662.662 0 01-.661-.663v-2.26a.662.662 0 111.324 0v2.26a.662.662 0 01-.663.663z"}}),_c('path',{attrs:{"d":"M16.391 19.848H7.9a1.756 1.756 0 01-1.755-1.753v-6.734A1.756 1.756 0 017.9 9.608h.255V8.17a3.99 3.99 0 117.98 0v1.438h.256a1.756 1.756 0 011.755 1.753v6.734a1.756 1.756 0 01-1.755 1.753zM7.9 10.768a.6.6 0 00-.595.593v6.734a.6.6 0 00.595.593h8.491a.594.594 0 00.593-.593v-6.734a.594.594 0 00-.593-.593zm1.35-1.16h5.789v-1.44a2.9 2.9 0 00-2.818-2.817h-.079A2.883 2.883 0 009.25 8.17z"}})])])
          )
        }
      }
    